"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InputEventUtil {
    static isInsertingText(event) {
        return event.inputType === "insertText";
    }
    static isDeletingText(event) {
        return event.inputType === "deleteContentBackward"
            || event.inputType === "deleteContentForward";
    }
    static getChar(event) {
        return event.data;
    }
}
exports.default = InputEventUtil;
//# sourceMappingURL=InputEventUtil.js.map